import AuthService from '@/plugins/api-plugin/services/auth.service'
import ClientService from '@/plugins/api-plugin/services/client.service'
import CommonLambdaService from '@/plugins/api-plugin/services/common-lambda.service'
import CommonService from '@/plugins/api-plugin/services/common.service'
import ManualJournalEntriesService from '@/plugins/api-plugin/services/manual-journal-entries.service'
import OrderService from '@/plugins/api-plugin/services/order.service'
import PortfolioService from '@/plugins/api-plugin/services/portfolio.service'
import RepricerService from '@/plugins/api-plugin/services/repricer.service'
import RepricerCdiscountService from '@/plugins/api-plugin/services/repricer-cdiscount.service'
import UserService from '@/plugins/api-plugin/services/user.service'
import { App, Plugin } from 'vue'
import SystemEventsService from '@/plugins/api-plugin/services/system-events.service'
import SystemEventsMonitorService from '@/plugins/api-plugin/services/system-events-monitor.service'
import SystemLogsService from '@/plugins/api-plugin/services/system-logs.service'
import InventoryService from '@/plugins/api-plugin/services/inventory.service'
import AdvertisingService from '@/plugins/api-plugin/services/advertising.service'
import BundleRecommendationsService from '@/plugins/api-plugin/services/bundle-recommendations.service'
import AwsService from '@/plugins/api-plugin/services/aws.service'
import SpCollectorService from '@/plugins/api-plugin/services/sp-collector.service'
import ApiKeysManagementService from '@/plugins/api-plugin/services/api-keys-management.service'
import RmaService from '@/plugins/api-plugin/services/rma.service'
import FailedImportsService from '@/plugins/api-plugin/services/failed-imports.service'
import PurchaseOrdersService from '@/plugins/api-plugin/services/purchase-orders.service'
import JobHistoryLogsService from '@/plugins/api-plugin/services/job-history-logs.service'
import DataProcessingSchedulerJobsService from '@/plugins/api-plugin/services/data-processing-scheduler-jobs.service'
import MessageQueuesService from '@/plugins/api-plugin/services/message-queues.service'
import SupportService from '@/plugins/api-plugin/services/support.service'
import CatalogueImportsService from '@/plugins/api-plugin/services/catalogue-imports.service'
import CustomersService from '@/plugins/api-plugin/services/customers.service'
import ChannelProfilesService from '@/plugins/api-plugin/services/channel-profiles.service'
import CreditNotesService from '@/plugins/api-plugin/services/credit-notes.service'
import EmailTemplatesService from '@/plugins/api-plugin/services/email-templates.service'
import ForSureClientsService from '@/plugins/api-plugin/services/forsure-clients.service'
import SupplierMessagesService from '@/plugins/api-plugin/services/supplier-messages.service'
import PaymentsService from '@/plugins/api-plugin/services/payments.service'
import ReleaseManagerService from '@/plugins/api-plugin/services/release-manager.service'
import FinanceReportService from '@/plugins/api-plugin/services/finance-report.service'
import LayoutsService from '@/plugins/api-plugin/services/layouts.service'
import OrderShipmentsService from '@/plugins/api-plugin/services/order-shipments.service'
import MaterialsManagementService from '@/plugins/api-plugin/services/materials-management.service'
import SalesOrdersService from '@/plugins/api-plugin/services/sales-orders.service'
import UserManagementService from '@/plugins/api-plugin/services/user-management.service'
import UserActivityService from '@/plugins/api-plugin/services/user-activity.service'

export interface ApiPluginInterface {
    auth: AuthService
    user: UserService
    client: ClientService
    repricer: RepricerService
    repricerCdiscount: RepricerCdiscountService
    common: CommonService
    portfolio: PortfolioService
    order: OrderService
    manualJournalEntries: ManualJournalEntriesService
    systemEvents: SystemEventsService
    systemEventsMonitor: SystemEventsMonitorService
    systemLogs: SystemLogsService
    inventory: InventoryService
    advertising: AdvertisingService
    bundleRecommendations: BundleRecommendationsService
    aws: AwsService
    spCollector: SpCollectorService
    apiKeysManagement: ApiKeysManagementService
    rma: RmaService
    failedImports: FailedImportsService
    purchaseOrders: PurchaseOrdersService
    jobHistoryLogs: JobHistoryLogsService
    dataProcessingSchedulerJobs: DataProcessingSchedulerJobsService
    messageQueues: MessageQueuesService
    support: SupportService
    catalogueImports: CatalogueImportsService
    customers: CustomersService
    channelProfiles: ChannelProfilesService
    creditNotes: CreditNotesService
    emailTemplates: EmailTemplatesService
    forSureClients: ForSureClientsService
    supplierMessages: SupplierMessagesService
    payments: PaymentsService
    releaseManager: ReleaseManagerService
    financeReport: FinanceReportService
    layouts: LayoutsService
    orderShipments: OrderShipmentsService
    materialsManagement: MaterialsManagementService
    salesOrders: SalesOrdersService
    userManagement: UserManagementService
    userActivity: UserActivityService
}

export interface ApiLambdaPluginInterface {}

export interface ApiPluginOptions {
    baseApiUrl: string
}

export const ApiPlugin: Plugin = {
    install: (app: App, options: ApiPluginOptions) => {
        const authService = new AuthService()
        const userService = new UserService(options.baseApiUrl, true)
        const clientService = new ClientService(options.baseApiUrl, true)
        const repricerService = new RepricerService(options.baseApiUrl, true)
        const repricerCdiscountService = new RepricerCdiscountService(options.baseApiUrl, true)
        const commonService = new CommonService(options.baseApiUrl, true)
        const portfolioService = new PortfolioService(options.baseApiUrl, true)
        const orderService = new OrderService(options.baseApiUrl, true)
        const manualJournalEntriesService = new ManualJournalEntriesService(options.baseApiUrl, true)
        const systemEventsService = new SystemEventsService(options.baseApiUrl, true)
        const systemEventsMonitorService = new SystemEventsMonitorService(options.baseApiUrl, true)
        const systemLogsService = new SystemLogsService(options.baseApiUrl, true)
        const inventoryService = new InventoryService(options.baseApiUrl, true)
        const advertisingService = new AdvertisingService(options.baseApiUrl, true)
        const bundleRecommendationsService = new BundleRecommendationsService(options.baseApiUrl, true)
        const awsService = new AwsService(options.baseApiUrl, true)
        const spCollectorService = new SpCollectorService(options.baseApiUrl, true)
        const apiKeysManagementService = new ApiKeysManagementService(options.baseApiUrl, true)
        const rmaService = new RmaService(options.baseApiUrl, true)
        const failedImportsService = new FailedImportsService(options.baseApiUrl, true)
        const purchaseOrdersService = new PurchaseOrdersService(options.baseApiUrl, true)
        const jobHistoryLogsService = new JobHistoryLogsService(options.baseApiUrl, true)
        const dataProcessingSchedulerJobsService = new DataProcessingSchedulerJobsService(options.baseApiUrl, true)
        const messageQueuesService = new MessageQueuesService(options.baseApiUrl, true)
        const supportService = new SupportService(options.baseApiUrl, true)
        const catalogueImportsService = new CatalogueImportsService(options.baseApiUrl, true)
        const customersService = new CustomersService(options.baseApiUrl, true)
        const channelProfilesService = new ChannelProfilesService(options.baseApiUrl, true)
        const creditNotesService = new CreditNotesService(options.baseApiUrl, true)
        const emailTemplatesService = new EmailTemplatesService(options.baseApiUrl, true)
        const forSureClientsService = new ForSureClientsService(options.baseApiUrl, true)
        const supplierMessagesService = new SupplierMessagesService(options.baseApiUrl, true)
        const paymentsService = new PaymentsService(options.baseApiUrl, true)
        const releaseManagerService = new ReleaseManagerService(options.baseApiUrl, true)
        const financeReportService = new FinanceReportService(options.baseApiUrl, true)
        const layoutsService = new LayoutsService(options.baseApiUrl, true)
        const orderShipmentsService = new OrderShipmentsService(options.baseApiUrl, true)
        const materialsManagementService = new MaterialsManagementService(options.baseApiUrl, true)
        const salesOrdersService = new SalesOrdersService(options.baseApiUrl, true)
        const userManagementService = new UserManagementService(options.baseApiUrl, true)
        const userActivityService = new UserActivityService(options.baseApiUrl, true)

        const ApiPlugin: ApiPluginInterface = {
            auth: authService,
            user: userService,
            client: clientService,
            repricer: repricerService,
            repricerCdiscount: repricerCdiscountService,
            common: commonService,
            portfolio: portfolioService,
            order: orderService,
            manualJournalEntries: manualJournalEntriesService,
            systemEvents: systemEventsService,
            systemEventsMonitor: systemEventsMonitorService,
            systemLogs: systemLogsService,
            inventory: inventoryService,
            advertising: advertisingService,
            bundleRecommendations: bundleRecommendationsService,
            aws: awsService,
            spCollector: spCollectorService,
            apiKeysManagement: apiKeysManagementService,
            rma: rmaService,
            failedImports: failedImportsService,
            purchaseOrders: purchaseOrdersService,
            jobHistoryLogs: jobHistoryLogsService,
            dataProcessingSchedulerJobs: dataProcessingSchedulerJobsService,
            messageQueues: messageQueuesService,
            support: supportService,
            catalogueImports: catalogueImportsService,
            customers: customersService,
            channelProfiles: channelProfilesService,
            creditNotes: creditNotesService,
            emailTemplates: emailTemplatesService,
            forSureClients: forSureClientsService,
            supplierMessages: supplierMessagesService,
            payments: paymentsService,
            releaseManager: releaseManagerService,
            financeReport: financeReportService,
            layouts: layoutsService,
            orderShipments: orderShipmentsService,
            materialsManagement: materialsManagementService,
            salesOrders: salesOrdersService,
            userManagement: userManagementService,
            userActivity: userActivityService,
        }

        const commonLambdaService = new CommonLambdaService(options.baseApiUrl, false)
        const ApiLambdaPlugin: ApiLambdaPluginInterface = {
            common: commonLambdaService,
        }
        app.provide<ApiPluginInterface>('api', ApiPlugin)
        app.provide<ApiLambdaPluginInterface>('apiLambda', ApiLambdaPlugin)
    },
}
